import React from "react";
import clsx from "clsx";

import {
  Tooltip,
  makeStyles,
  colors,
  Button,
  Typography,
} from "@material-ui/core";

import { LoadedDestinationInfo } from "../types/global";
import { isDestinationInHIPAAMode } from "../util";
import Label from "../Label";

const useStyles = makeStyles((theme) => ({
  label: {
    width: 120,
    fontSize: "14px",
  },
}));

export const HIPAAModeLabel: React.FC<{ dest: LoadedDestinationInfo }> = ({
  dest,
}) => {
  const classes = useStyles();
  const hasBAA = !isDestinationInHIPAAMode(dest);
  return (
    <Tooltip
      title={
        hasBAA
          ? "ID Masking and Allowlisting disabled."
          : "ID Masking and Allowlisting enabled."
      }
    >
      <span>
        <Label
          style={{ textTransform: "none" }}
          variant="no-background"
          className={clsx(classes.label)}
        >
          {hasBAA ? "Allowing PHI" : "Restricting PHI"}
        </Label>
      </span>
    </Tooltip>
  );
};
